import { FunctionComponent, useContext, useEffect, useState } from "react";
import styles from "./RecentNotification.module.css";
import { NotificationDataType,getFormattedDate,notificationData } from "../../../../helper";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "moment-timezone";
import images from "../../../../assets/images";
import { globalContext } from "../../../../Provider/AppProvider";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_NOTIFICATIONS, UPDATE_READ_STATUS } from "../api/NotificationQuery";

const RecentNotification: FunctionComponent<NotificationDataType> = ({
  notificationData,
  handleClose,
}) => {
  const navigate = useNavigate();
  const [timeAgoList, setTimeAgoList] = useState<string[]>([]);
  const {globalState,handleGlobalState} = useContext<any>(globalContext);

  const [getWebNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempData = {...globalState}
      tempData.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempData.notificationCount.past = data?.pastCount?.aggregate?.count
      tempData.notification.reSettingNotificationCount = !globalState.notification.reSettingNotificationCount
      handleGlobalState(tempData)
    }
  })
  
  const [updateReadStatus] = useMutation(UPDATE_READ_STATUS,{fetchPolicy:"no-cache",
  onCompleted: (data) =>{
    const date = getFormattedDate(new Date());
    getWebNotification({
      variables:{
        todayDate: date,
        userId: globalState?.profile?.id
      }
    })
  }
})

  

  const handleClick = (recentNotification:notificationData) => {
    const tempStateForRecent = {...globalState};
    tempStateForRecent.notification.text = recentNotification?.type==="DeleteUser"?`${recentNotification?.title.slice(0, recentNotification?.title.indexOf("account"))} [deleted user]`:recentNotification?.title.slice(0, recentNotification?.title.indexOf("requested"));
    tempStateForRecent.notification.notificationClicked = true;
    tempStateForRecent.notification.ticketId = recentNotification?.ticket?.t_id ?? null;
    tempStateForRecent.notification.tpId = recentNotification?.ticket_placement?.tp_id ?? null;
    tempStateForRecent.notification.tp_id_array=recentNotification?.tp_id_array??null;
    tempStateForRecent.notification.notificationSearchCancel = !globalState.notification.notificationSearchCancel;
    handleGlobalState(tempStateForRecent);
    navigate("/tickets");
    updateReadStatus({
      variables:{
        feedId:recentNotification?.f_id
      }
    });
    handleClose();
  };

  const { DefaultProfile } = images;

  useEffect(() => {
    const calculateTimeAgo = () => {
      const currentTime = moment.utc();

      const timeAgoArray = notificationData?.map((notification: notificationData) => {
        const notificationTime = moment(notification.notification);
        const diffMinutes = currentTime.diff(notificationTime, "minutes");

        if (diffMinutes < 60) {
          return `${diffMinutes} mins ago`;
        } else {
          const diffHours = currentTime.diff(notificationTime, "hours");
          return `${diffHours} hours ago`;
        }
      });

      setTimeAgoList(timeAgoArray as string[]);
    };

    calculateTimeAgo();

    // Clean up
    return () => {
      setTimeAgoList([]);
    };
  }, [notificationData]);
  return (
    <div className={styles.recentNotification}>
      <div className={styles.recent}>
        <b className={styles.recent1}>Recent</b>
      </div>
      <div className={styles.notificationCards}>
        {notificationData?.map((recentNotification: notificationData, index: number) => (
          <div
            key={recentNotification?.ticket?.event?.e_id}
            className={styles.notification}
            onClick={() => handleClick(recentNotification)}
          >
            <div className={styles.container}>
              <div className={styles.all}>
                <div className={styles.img}>
                  <img
                    className={styles.imgIcon}
                    alt=""
                    src={
                      recentNotification?.ticket?.event?.eventImage
                        ? recentNotification?.ticket?.event?.eventImage
                        : DefaultProfile
                    }
                  />
                </div>
                <div className={styles.content}>
                  <div className={styles.text}>
                    <b className={recentNotification?.type==="DeleteUser"?styles.deleteUser:styles.mainTitle}>
                      {recentNotification?.title ?? ""}
                    </b>
                  </div>
                  <div className={styles.subText}>
                    <div className={styles.subTitle}>
                      {`${recentNotification?.ticket?.event?.eventName ?? ""} ${
                        recentNotification?.ticket?.event?.eventDate
                          ? moment(recentNotification?.ticket?.event?.eventDate)
                              .tz("America/Chicago")
                              .format('ddd DD MMM, hh:mm A z')
                          : ""
                      }`}
                    </div>
                    <div className={styles.text1} />
                    <div className={styles.subTitle}>
                      {recentNotification?.ticket?.event?.eventAddress ?? ""}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.tagTimeStamp}>
                <div className={styles.minsAgo}>{timeAgoList[index]}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentNotification;
